import { useApplicationModals } from "app/common/hooks";
import { Badge } from "app/components/atoms/badge";
import {
  BadgeButton,
  ServerSidePaginationButtons
} from "app/components/atoms/button";
import { Input } from "app/components/atoms/input";
import { FormHeader } from "app/components/atoms/layout";
import { Select, SelectSearch } from "app/components/atoms/select";
import Table from "app/components/atoms/table";
import { InputMolecule } from "app/components/molecules/form";
import ImageWithPreview from "app/components/molecules/imageWithPreview";
import api from "app/integration/api";
import { useCollector, useUpdateForm } from "app/integration/common/hooks";
import MainLayout from "app/layouts/main";
import AppModals from "app/modals";
import clsx from "clsx";
import { FieldArray, Formik, getIn } from "formik";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";

const breadcrumbItems = [
  { label: "Gudang", href: "/receive_order" },
  { label: "Penerimaan", href: "/receive_order" },
  { label: "Terima Barang", href: "#" },
];

function UpdateReceiveOrder() {
  let { id } = useParams();
  const navigate = useNavigate();
  let isError = false;

  const handleSuccess = (res) => {
    console.log(res);
    navigate("/receive_order");
  };

  const [isLoading, setIsloading] = useState(false);
  const [receive, setReceive] = useState([]);
  const [defaultStatus, setDefaultStatus] = useState(1);
  const [isCreateNew, setCreateNew] = useState(false);
  const typingTimer = useRef(null);
  const doneTypingInterval = 2000;
  const [paginationProps, setPaginationProps] = useState([]);

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  // console.log(today);

  const [params, setParams] = useState({
    search: "",
    createdAt: null,
    supplier_id: null,
    status: null,
    is_valid_order: null,
    page: 1,
    limit: 50,
    sort:"DESC",
    order:"createdAt"
  });

  const [suppliers, setMSuppliers, suppliersLoader, collectMSuppliers] =
    useCollector({ modelName: "supplier" });

  const { initialValues, setInitialValues, validationSchema, onSubmit } =
    useUpdateForm({
      initialValues: {
        items: [],
      },
      validationSchema: Yup.object().shape({
        items: Yup.array()
          .of(
            Yup.object().shape({
              qty: Yup.number()
                .required("Qty harus diisi.")
                .min(0, "Qty diterima minimal 0."),
            })
          )
          .min(1, "Minimal harus ada 1 Item yang dibeli."),
      }),
      onSubmit: async (values) => {
        try {
          setIsloading(true);
          let response = await api.receiveOrder.update(
            values.id,
            values.status
          );

          if (response && response.status == "success") {
            isError = false;
            setIsloading(false);
          }
          return response;
        } catch (error) {
          setPayloads("errorMessage.view", {
            title: "Update Penerimaan Barang",
            message: error?.response?.data?.message
              ? error?.response?.data?.message
              : "Server Error",
          });
          isError = true;
          openModal("errorMessage.view");
          setIsloading(false);
        }
      },
      onSuccess: () => !isError && handleSuccess(),
    });

  const { openModal, setPayloads } = useApplicationModals();
  const [currentErrors, setCurrentErrors] = useState([]);

  function runValidations(values) {
    validationSchema
      .validate(values, { abortEarly: false })
      .then((responseData) => {
        console.log("no validation errors");
        console.log(responseData);
        setCurrentErrors([]);
      })
      .catch((err) => {
        console.log(err);
        console.log(err.name); // ValidationError
        console.log(err.errors);
        setCurrentErrors(err.errors);

        setPayloads("errorMessage.view", {
          title: "Tambah Order Error",
          data: err.errors,
        });
        openModal("errorMessage.view");
      });
  }

  const getReceive = async () => {
    try {
      console.log("id: ", id);
      const response = await api.receiveOrderItem.index(params);

      if (response && response.status == "success") {
        setInitialValues({
          items: [],
        });
        setReceive(response.data);
        setPaginationProps(response.pagination);
      }
    } catch (err) {
      setReceive([]);
      console.log("error: ", err);
    }
  };

  const [receiveOrderLoadingState, setReceiveOrderLoadingState] = useState([]);

  // Add this near other state declarations
  const [activeTab, setActiveTab] = useState('pending'); // 'pending' or 'received'

  // Add this after the FormHeader component
  const [pendingItems, setPendingItems] = useState([]);
  const [receivedItems, setReceivedItems] = useState([]);

  const updateOrderItem = async (
    item_id,
    qty,
    status,
    receiveAllItem = false
  ) => {
    let newReceiveOrderLoadingState = [...receiveOrderLoadingState];
    newReceiveOrderLoadingState.push(item_id);
    await setReceiveOrderLoadingState(newReceiveOrderLoadingState);
    try {
      const response = await api.receiveOrderItem.update(
        item_id,
        qty,
        status,
        receiveAllItem
      );
      newReceiveOrderLoadingState = [...receiveOrderLoadingState];
      newReceiveOrderLoadingState.splice(
        newReceiveOrderLoadingState.indexOf(item_id),
        1
      );
      await setReceiveOrderLoadingState(newReceiveOrderLoadingState);

      if (response && response.status == "success") {
        console.log("update qty berhasil");
        await getReceive();
      }
    } catch (err) {
      console.log("error: ", err);
      setPayloads("errorMessage.view", {
        title: "Error Terima Barang",
        message: err?.response?.data?.message
          ? err?.response?.data?.message
          : "Server Error",
      });
      isError = true;
      openModal("errorMessage.view");
      setIsloading(false);
    }
  };

  const handleUpdate = (item_id, qty, old_qty) => {
    if (qty < old_qty) {
      setPayloads("receiveOrderItem.update", { id: item_id, qty });
      openModal("receiveOrderItem.update");
    } else {
      updateOrderItem(item_id, qty, false, true);
    }
  };

  const handleKeyUp = () => {
    clearTimeout(typingTimer.current);
    typingTimer.current = setTimeout(doneTyping, doneTypingInterval);
  };

  const handleKeyDown = () => {
    clearTimeout(typingTimer.current);
  };

  const doneTyping = () => {
    getReceive();
  };

  /**
   * handlePrintQrCode
   *
   * Memproses penanganan cetak QR code ketika pengguna menekan tombol cetak pada item receive order.
   *
   * Alur:
   * 1. Mengambil data barcode unik dari `api.productCode.index`.
   * 2. Jika API mengembalikan HTTP 404 ("Belum ada data"), item diperlakukan sebagai non-unik
   *    (varian per-kuantitas) dan mengambil data varian via `api.productVariant.index`.
   * 3. Jika API mengembalikan error selain 404 (misal: 500, 401, 403, timeout, network failure),
   *    error dilempar ulang (rethrow) ke outer catch agar modal pesan error ditampilkan ke pengguna.
   *
   * @param {Object} item - Objek item receive order yang dipilih.
   * @param {string} item.receive_code - Kode referensi penerimaan barang.
   * @param {number|string} item.product_id - ID produk utama.
   * @param {number|string} item.size_variant_id - ID varian ukuran produk.
   * @param {number|string} item.color_variant_id - ID varian warna produk.
   * @param {string} item.product_name - Nama produk.
   * @param {string} item.product_code - Kode SKU produk/varian.
   * @param {number} [item.order_qty] - Kuantitas pesanan.
   * @param {number} [item.qty] - Kuantitas penerimaan aktual.
   * @returns {Promise<void>} Tidak mengembalikan nilai.
   * @throws {Error} Melempar error ke outer block jika terjadi kegagalan jaringan atau server.
   * @sideEffects
   * - Menyetel payload modal "qrCode.view" dan membukanya jika data berhasil didapat.
   * - Menyetel payload modal "errorMessage.view" dan membukanya jika terjadi kegagalan sistem.
   */
  const handlePrintQrCode = async (item) => {
    try {
      let productCodes = [];
      try {
        // Fetch product codes untuk receive order ini
        const response = await api.productCode.index({
          ref: item.receive_code,
          limit: 9999,
        });
        productCodes = response?.data || [];
      } catch (pcErr) {
        // Hanya tangani HTTP 404 ("Belum ada data") sebagai indikasi sah item non-unik
        const isNotFound = pcErr?.response?.status === 404;
        if (!isNotFound) {
          // Rethrow error lain (500, 401, 403, timeout, network error) ke outer catch
          throw pcErr;
        }

        console.log(
          "No product codes found for receive_code (404), treating as non-unique variant item:",
          pcErr
        );
        productCodes = [];
      }

      if (productCodes && productCodes.length > 0) {
        // BARCODE UNIK PER-PCS
        const codesWithDetails = productCodes.map((code) => ({
          ...code,
          qr_code: code.qr_code,
          product_detail: code.product_variant?.product_detail,
          size: { name: item.size },
          color: { name: item.color },
        }));

        setPayloads("qrCode.view", {
          product: codesWithDetails,
          multiple: true,
          isVariant: false,
        });
        openModal("qrCode.view");
      } else {
        // BARCODE NON-UNIK (VARIAN)
        const variantRes = await api.productVariant.index({
          product_id: item.product_id,
          size_variant_id: item.size_variant_id,
          color_variant_id: item.color_variant_id,
          limit: 1,
        });
        const variantData = variantRes?.data?.[0];

        const variantWithDetails = {
          id: variantData?.id || item.id,
          // Fallback ke kode produk DISENGAJA dan tetap bisa dipindai: untuk
          // barang non-unik, resolver scan POS mencocokkan `qr_code` varian
          // MAUPUN `code` produk (`src/offline/scan.ts`, cermin cabang (b)/(c)
          // di `PosProductService`) dan mengembalikannya sebagai baris qty biasa.
          // Jadi label tetap berguna walau varian tidak ketemu di master.
          qr_code: variantData?.qr_code || item.product_code,
          product_detail: {
            name: item.product_name,
            code: item.product_code,
            price: variantData?.product_detail?.price || item.master_product?.price || 0,
          },
          size: { name: item.size },
          color: { name: item.color },
        };

        setPayloads("qrCode.view", {
          product: [variantWithDetails],
          multiple: true,
          isVariant: true,
          count: item.order_qty || item.qty || 1,
        });
        openModal("qrCode.view");
      }
    } catch (err) {
      console.error("Error loading QR codes:", err);
      setPayloads("errorMessage.view", {
        title: "Error Loading QR Codes",
        message:
          err?.response?.data?.message ||
          err?.message ||
          "Failed to load QR codes",
      });
      openModal("errorMessage.view");
    }
  };

  useEffect(() => {
    getReceive();
  }, [params]);

  useEffect(() => {
    console.log("receive: ", receive);
    setDefaultStatus(receive.status);
    setInitialValues({
      items: receive?.filter(item => activeTab === 'pending' ? item.status === 1 : item.status !== 1).map((item) => ({
        id: item.id,
        imageUrl: item?.master_product?.imageUrl,
        product_name: item?.master_product?.name,
        product_code: item?.master_product?.code,
        color: item?.master_color?.name,
        size: item?.master_size?.name,
        supplier_id: item.supplier_id,
        product_id: item.product_id,
        size_variant_id: item.size_variant_id,
        color_variant_id: item.color_variant_id,
        status: item.status,
        qty: 0,
        order_qty: item.qty,
        old_qty: item.qty,
        receive_code: item?.ReceiveOrder?.receive_code,
        supplier_firstName: item?.ReceiveOrder?.MSupplier?.firstName,
        supplier_lastName: item?.ReceiveOrder?.MSupplier?.lastName,
        supplier_middleName: item?.ReceiveOrder?.MSupplier?.middleName,
        supplier_nickName: item?.ReceiveOrder?.MSupplier?.nickName,
        purchase_code: item?.purchase_order?.purchase_code,
      })),
    });
    console.log("initial: ", initialValues);
  }, [receive, activeTab]);

  return (
    <MainLayout
      activeSidebarNavigation="warehouse"
      activeSidebarChild="receive"
      breadcrumbItems={breadcrumbItems}
      pageTitle={`Terima Barang`}
      headingButtons={[]}
    >
      <AppModals
        items={["errorMessage.view", "qrCode.view"]}
        onSuccess={{
          "errorMessage.view": () => fetch(),
          "qrCode.view": () => { },
        }}
      />
      <AppModals
        items={["receiveOrderItem.update", "receiveOrderItem.confirm"]}
        onSuccess={{
          "receiveOrderItem.update": async (status, id, qty) => {
            console.log("status update: ", status, id, qty);
            await updateOrderItem(id, qty, status);
          },
          "receiveOrderItem.confirm": (id, qty, old_qty) => {
            handleUpdate(id, qty, old_qty);
          },
        }}
      />
      <FormHeader appearance="none">
        <SelectSearch testId="receive-order-supplier-select"
          label="Supplier"
          placeholder="Filter Supplier"
          options={suppliers
            ?.sort(function (a, b) {
              if (a.firstName?.toLowerCase() < b.firstName?.toLowerCase())
                return -1;
              if (a.firstName?.toLowerCase() > b.firstName?.toLowerCase())
                return 1;
              return 0;
            })
            .map((supplier) => ({
              value: supplier.id,
              label:
                supplier.firstName +
                " " +
                supplier.middleName +
                " " +
                supplier.lastName +
                (supplier.nickName ? " (" + supplier.nickName + ")" : ""),
            }))}
          value={params.supplier_id}
          onChange={async (e) => {
            setParams({ ...params, supplier_id: e.target.value });
          }}
        />
        <Input testId="receive-order-nama-product-input"
          label="Nama Product"
          placeholder="Search..."
          type="text"
          value={params.search}
          onChange={async (e) =>
            setParams({ ...params, search: e.target.value })
          }
          onKeyUp={handleKeyUp}
          onKeyDown={handleKeyDown}
        />
        <Select testId="receive-order-sorting-select"
          label="Sorting"
          placeholder="Sorting"
          options={[
            { value: "DESC", label: "Terbaru" },
            { value: "ASC", label: "Terlama" },
          ]}
          value={params.sort}
          onChange={async (e) => {
            setParams({ ...params, sort: e.target.value });
          }}
        />
      </FormHeader>
      <div className="flex border-b mb-4">
        <button data-testid="receive-order-pending-button"
          className={`px-4 py-2 font-medium ${activeTab === 'pending'
            ? 'border-b-2 border-blue-500 text-blue-600'
            : 'text-gray-500 hover:text-gray-700'
            }`}
          onClick={() => {
            getReceive();
            setActiveTab('pending');
          }}
        >
          Pending ({receive?.filter(item => item.status === 1).length})
        </button>
        <button data-testid="receive-order-diterima-button"
          className={`px-4 py-2 font-medium ${activeTab === 'received'
            ? 'border-b-2 border-blue-500 text-blue-600'
            : 'text-gray-500 hover:text-gray-700'
            }`}
          onClick={() => {
            getReceive();
            setActiveTab('received');
          }}
        >
          Diterima ({receive?.filter(item => item.status !== 1).length})
        </button>
      </div>
      <Formik
        {...{ initialValues, validationSchema, onSubmit }}
        enableReinitialize={true}
      >
        {({
          values,
          errors,
          status,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form
            className={clsx("px-2 overflow-y-auto")}
            onSubmit={handleSubmit}
          >
            <div className="overflow-visible">
              <div className="w-full">
                <FieldArray name="items">
                  {(arrayHelpers) => (
                    <Table.Wrapper asIndex={true}>
                      <Table.Header>
                        <Table.HeaderRow>
                          <Table.Heading>Code</Table.Heading>
                          <Table.Heading>Purchase Code</Table.Heading>
                          <Table.Heading>Supplier</Table.Heading>
                          <Table.Heading>Nama</Table.Heading>
                          <Table.Heading>Kode</Table.Heading>
                          <Table.Heading>Warna</Table.Heading>
                          <Table.Heading>Size</Table.Heading>
                          <Table.Heading>Dipesan</Table.Heading>
                          <Table.Heading>Qty Diterima</Table.Heading>
                          <Table.Heading>Status</Table.Heading>
                          <Table.Heading></Table.Heading>
                        </Table.HeaderRow>
                      </Table.Header>
                      <Table.Body>
                        {values?.items?.length > 0 &&
                          values.items.map((item, key) => (
                            <Table.BodyRow key={key}>
                              <Table.Cell size="xs">
                                <span
                                  className="text-blue-600 hover:text-blue-800 hover:underline cursor-pointer"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handlePrintQrCode(item);
                                  }}
                                >
                                  {item.receive_code}
                                </span>
                              </Table.Cell>
                              <Table.Cell>
                                {item?.purchase_code}
                              </Table.Cell>
                              <Table.Cell size="xs">
                                <p>
                                  {item.supplier_firstName}{" "}
                                  {item.supplier_lastName}
                                </p>
                              </Table.Cell>
                              <Table.Cell size="xs">
                                <div className="flex items-center gap-2">
                                  {item?.imageUrl && (
                                    <ImageWithPreview
                                      src={`${process.env.REACT_APP_AWS_LINK_URL}${item?.imageUrl}`}
                                    ></ImageWithPreview>
                                  )}
                                  <p>{item.product_name}</p>
                                </div>
                              </Table.Cell>
                              <Table.Cell size="xs">
                                <p>{item.product_code}</p>
                              </Table.Cell>

                              <Table.Cell size="xs">
                                <p>{item.color}</p>
                              </Table.Cell>
                              <Table.Cell size="xs">{item.size}</Table.Cell>
                              <Table.Cell size="xs" align="right">
                                <p className="text-center">
                                  {item.status == 1 ? item.order_qty : ""}
                                </p>
                              </Table.Cell>
                              <Table.Cell size="xs">
                                <div className="w-20 text-center">
                                  {item.status == 1 ? (
                                    <InputMolecule testId="receive-order-items-qty-input"
                                      hideLabel={true}
                                      type="number"
                                      name={`items[${key}].qty`}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      onBlur={handleBlur}
                                      value={0}
                                      errorMessage={
                                        getIn(errors, `items[${key}].qty`) &&
                                        getIn(touched, `items[${key}].qty`) &&
                                        getIn(errors, `items[${key}].qty`)
                                      }
                                      align="right"
                                      size="xs"
                                    />
                                  ) : (
                                    item.order_qty
                                  )}
                                </div>
                              </Table.Cell>
                              <Table.Cell size="xs">
                                <Badge
                                  color={item.status == 1 ? "yellow" : "green"}
                                >
                                  {item.status == 1 ? "Tunggu" : "Diterima"}
                                </Badge>
                              </Table.Cell>
                              <Table.Cell size="xs">
                                {item.status == 1 && (
                                  <BadgeButton testId="receive-order-terima-button"
                                    color="green"
                                    onClick={() => {
                                      // Modal aplikasi, bukan window.confirm:
                                      // dialog native memblokir browser dan
                                      // tidak bisa diotomasi/diuji.
                                      setPayloads("receiveOrderItem.confirm", {
                                        id: item.id,
                                        qty: item.qty,
                                        old_qty: item.old_qty,
                                        label: `${item.product_name} ${item.size} ${item.color}`,
                                      });
                                      openModal("receiveOrderItem.confirm");
                                    }}
                                    useLoadingState={true}
                                    loading={receiveOrderLoadingState?.includes(
                                      item.id
                                    )}
                                  >
                                    Terima
                                  </BadgeButton>
                                )}
                              </Table.Cell>
                            </Table.BodyRow>
                          ))}
                      </Table.Body>
                    </Table.Wrapper>
                  )}
                </FieldArray>
              </div>
            </div>
          </form>
        )}
      </Formik>
      <Table.PaginationWrapper>
        <ServerSidePaginationButtons
          paginationProps={paginationProps}
          params={params}
          setParams={setParams}
        />
      </Table.PaginationWrapper>
    </MainLayout>
  );
}

export default UpdateReceiveOrder;
